import DomainBaseEntities from "@/utils/constants/DomainBaseEntities.ts";
import OverrideSelectedDimension from "@/utils/constants/OverrideSelectedDimension.ts";
import DimensionsUtil from "@/utils/common/DimensionsUtil.ts";
import ObjectChecker from "@/utils/common/ObjectChecker.ts";
import FieldType from "@/utils/constants/FieldType.ts";
import LoginUtils from "@/utils/login/LoginUtils.ts";
import FieldTypesUtils from "@/utils/common/FieldTypesUtils.ts";
import DTOHasOverrideDimensionOptions = namaTypes.DTOHasOverrideDimensionOptions;
import EntityReferenceData = namaTypes.EntityReferenceData;
import ReportMetadataContainer = namaTypes.ReportMetadataContainer;
import DTOFilledQuestionField = namaTypes.DTOFilledQuestionField;
import QuestionField = namaTypes.QuestionField;

export default class ReportDimensionParametersOverrider {

  static getOverrideSelectedDimension(dimType: string, report: DTOHasOverrideDimensionOptions | undefined): string | undefined {
    if (!report)
      return;
    if (ObjectChecker.areEqual(dimType, DomainBaseEntities.LegalEntity))
      return report.overrideSelectedLegalEntity;
    if (ObjectChecker.areEqual(dimType, DomainBaseEntities.Sector))
      return report.overrideSelectedSector;
    if (ObjectChecker.areEqual(dimType, DomainBaseEntities.Department))
      return report.overrideSelectedDepartment;
    if (ObjectChecker.areEqual(dimType, DomainBaseEntities.Branch))
      return report.overrideSelectedBranch;
    if (ObjectChecker.areEqual(dimType, DomainBaseEntities.AnalysisSet))
      return report.overrideSelectedAnalysisSet;
    return;
  }


  static shouldOverride(dimType: string, dim: EntityReferenceData | undefined | null, report: ReportMetadataContainer): boolean {
    let overrideMethod = this.getOverrideSelectedDimension(dimType, report.reportOverrideOptions);
    if (!overrideMethod)
      overrideMethod = this.getOverrideSelectedDimension(dimType, report.globalOverrideOptions);
    if (!overrideMethod || ObjectChecker.areEqual(overrideMethod, OverrideSelectedDimension.Never))
      return false;
    if (ObjectChecker.areEqual(overrideMethod, OverrideSelectedDimension.Always))
      return true;
    if (ObjectChecker.areEqual(overrideMethod, OverrideSelectedDimension.WhenNotPublic) && dim && DimensionsUtil.isNotNullDimension(dim) && !dim['composite'])
      return true;
    return false;
  }

  static overrideDimensionsIfNeed(filledQuestionFields: DTOFilledQuestionField[], report: ReportMetadataContainer | undefined): void {
    if (!report)
      return;
    let questionFields: QuestionField[] = report.metadata && report.metadata.questionFields ? report.metadata.questionFields : [];
    for (let questionField of questionFields) {
      if ((questionField.fieldType == FieldType.Reference || questionField.fieldType == FieldType.Genericreference) && questionField.metaData &&
        ObjectChecker.isAnyEqualToFirst(questionField.metaData.referencedEntityType, DomainBaseEntities.LegalEntity,
          DomainBaseEntities.Sector, DomainBaseEntities.Branch, DomainBaseEntities.Department, DomainBaseEntities.AnalysisSet)) {
        let filledQuestionField: DTOFilledQuestionField | undefined = filledQuestionFields.find(l => l.id === questionField.id);
        let dimType: string = questionField.metaData.referencedEntityType ?? '';
        let dimId: EntityReferenceData | undefined = LoginUtils.loginInfo && LoginUtils.loginInfo.dimensions ? LoginUtils.loginInfo?.dimensions[dimType] : undefined;
        if (this.shouldOverride(dimType, dimId, report) && (!filledQuestionField || !filledQuestionField.value)) {
          let overrideValue: DTOFilledQuestionField = {
            id: questionField.id,
            value: FieldTypesUtils.toString(FieldType.Reference, dimId),
            objValue: dimId
          } as DTOFilledQuestionField;
          filledQuestionFields = filledQuestionFields.filter(l => l.id !== overrideValue.id);
          filledQuestionFields.push(overrideValue);
        }
      }
    }
  }
}
